import { useAccount } from 'wagmi'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'
 import Chain from "./components/Chain";
 import SToken from "./components/SToken";
 import TokenBalance from "./components/TokenBalance";
 import TokenTransfer from "./components/TokenTransfer";

const Token = () => {

    const { isConnected, isDisconnected } = useAccount();

    return (
        <>

            <h1 className="title">
                    <Link to="/">SkidCoin</Link>
            </h1>
            
            <motion.div 
                className="container Mint"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <main className="main">

                    {isConnected ? (
                        <div className="page-content">
                            <Chain />
                            {/*<SToken />*/}
                            <TokenBalance />
                            <TokenTransfer />
                        </div>
                    ) : !isConnected && (
                        <div className="page-content center">
                            <h6>Connect your wallet to access this page.</h6>
                        </div>
                    )}

                </main>

            </motion.div>

        </>

    );
};

export default Token;